<template>
  <div>
    <v-layout column>
      <v-flex md4 class="pl-2">
        <label class="cmr-label-text">Associate Taxi</label>
      </v-flex>
      <v-flex xs12 md8 pb-4>
        <v-layout align-center justify-start row>
          <v-autocomplete
              v-model="taxiStore"
              :error-messages="errorForField()"
              :items="taxiSearch"
              :loading="loading"
              :search-input.sync="search"
              item-text="registration_number"
              dense
              outlined
              placeholder="Search by registration or plate number"
              hide-no-data
              hide-selected
              no-filter
              return-object
              clearable
              :disabled="false"
              hide-details
              @input="handleSelected"
              class="text-none mr-2"
          >
            <template v-slot:item="{ item }">
              {{ item.registration_number }}
            </template>
          </v-autocomplete>
          <v-btn color="success" @click="associateTaxi" class="text-none mr-2">Associate Taxi</v-btn>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-data-table
        style="width: 100%"
        :headers="headers"
        :items="taxis"
    >
      <template v-slot:item="props">
        <tr>
          <td style="width: 7%">{{ props.item.registration_number }}</td>
          <td style="width: 7%">{{ props.item.plate_number }}</td>
          <td style="width: 7%">{{ props.item.council }}</td>
          <td style="width: 25%">
            <v-row>
              <v-btn
                  @click="dissociateTaxi(props.item.id)"
                  x-small
                  style=""
              >Remove Taxi
              </v-btn>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>

  </div>
</template>


<script>

import axios from "axios";
import AttributesForTaxiCell from "@/components/widget/AttributesForTaxiCell.vue";

axios.defaults.withCredentials = true;

export default {
  name: "associated_taxis",
  components: {
    AttributesForTaxiCell,
  },
  props: {
    driver: Object,
    query: Object,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Registration Number",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Plate Number",
          align: "left",
          sortable: false,
          value: "document",
        },
        {
          text: "Council",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "taxi",
        }
      ],
      taxis: [],
      taxiStore: {},
      loading: false,
      taxiSearch: [],
      search: null,
      selectedTaxi: {}
    };
  },
  watch: {
    search(query) {
      console.log(query);
      this.resetError();

      if (query == null) return;
      if (query.length <= 2) return;
      if (this.loading) return;

      this.loading = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/taxi/search?query=${query}`;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
          .then(function(res) {
            self.taxiSearch = res.data.taxis;
            self.loading = false;
          })
          .catch(function(err) {
            console.error(err);
            self.loading = false;
          });
    }
  },
  mounted: async function () {
    this.getAssociatedTaxis();
  },
  computed: {
  },
  methods: {
    getAssociatedTaxis: async function () {
      this.loading = true;

      try {
        let url = `${this.$store.state.apiUrl}/taxi/driver/associatedTaxis/list?driver_id=${this.$route.params.id}`;

        let response = await axios.get(url, {
          params: {},
        });

        this.taxis = response.data.taxis;
        console.log("Associated Taxis Response", this.taxis);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get associated taxis " + error);
      }
    },
    handleSelected: function () {
      this.selectedTaxi = this.taxiStore;
    },
    errorForField: function () {
      try {
        return this.errors["use_existing"];
      } catch (err) {
        return null;
      }
    },
    resetError: function () {
      try {
        if (this.errors["use_existing"] !== "") {
          this.errors["use_existing"] = "";
        }
      } catch (err) {
      }
    },
    associateTaxi: async function () {
      let url = `${this.$store.state.apiUrl}/taxi/associate/driver?taxi_id=${this.selectedTaxi.id}&driver_id=${this.driver.callsign}`;

      try {
        let response = await axios.post(url, {
          params: {},
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });

        this.refresh();
      } catch (error) {
        console.log(error);
      }
    },
    dissociateTaxi: async function (taxiId) {
      let url = `${this.$store.state.apiUrl}/taxi/dissociate/driver?taxi_id=${taxiId}&driver_id=${this.driver.callsign}`;

      try {
        let response = await axios.post(url, {
          params: {},
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });

        this.refresh();
      } catch (error) {
        console.log(error);
      }
    },
    refresh: function () {
      this.getAssociatedTaxis();
    },
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 18px;
}
</style>
